<template>
  <div class="sign-in">
    <div class="sign-in-form">
      <div class="sign-in-logo">
        <h1>
          <i class="bi-eagle-logo"><span class="a11y-invisible">EAGLE</span></i>
        </h1>
      </div>

      <template v-if="errorMessage">
        <p class="sso-error">{{ errorMessage }}</p>
        <ui-button :color="'blue'"
                   :width="'100%'"
                   @click="worksLogin">
          다시 로그인
        </ui-button>
      </template>
      <p v-else class="sso-loading">NAVER WORKS 로그인으로 이동 중...</p>
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/_ui/UiButton'

const ERROR_MESSAGE = {
  no_code: '인증 코드를 받지 못했습니다.',
  token: '토큰 발급에 실패했습니다.',
  userinfo: '사용자 정보를 불러오지 못했습니다.',
  domain: '허용되지 않은 계정입니다. (4grit.com 계정만 로그인할 수 있습니다.)'
}

export default {
  name: 'SignIn',
  components: {
    UiButton
  },
  data () {
    return {
      errorMessage: ''
    }
  },
  created () {
    // SSO 인증 실패로 돌아온 경우엔 자동 리다이렉트하지 않고 에러를 표시(루프 방지)
    const ssoError = this.$route.query.ssoError
    if (ssoError) {
      this.errorMessage = ERROR_MESSAGE[ssoError] || 'NAVER WORKS 로그인에 실패했습니다.'
      return
    }
    // 미로그인 상태이면 곧바로 WORKS 인증으로 이동
    this.worksLogin()
  },
  methods: {
    worksLogin () {
      window.location.href = `${process.env.VUE_APP_API_BASE_URL}/admin/user/sso`
    }
  }
}
</script>

<style lang="scss" scoped>
  .sign-in {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    &::before {
      content: "";
      z-index: -2;
      position: absolute;
      top: -15px;
      left: -15px;
      width: calc(100% + 30px);
      height: calc(100% + 30px);
      background: url('~@/assets/signin-background.jpg') no-repeat center center;
      filter: blur(15px);
      background-size: cover;
    }

    &::after {
      content: "";
      z-index: -1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: $white;
      opacity: 0.8;
    }

    .sign-in-form {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: $white;
      border-radius: 15px;
      padding: 20px;
      box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08);

      .sign-in-logo {
        padding: 210px 20px 30px;
        margin: -20px -20px 20px;
        border-radius: 15px 15px 0 0;
        background-color: $blue;

        h1 {
          color: #ffffff;
          font-weight: bold;
          font-size: 30px;
        }
      }

      .sso-error {
        margin-bottom: 15px;
        color: #e02020;
        font-size: 14px;
        text-align: center;
      }

      .sso-loading {
        font-size: 14px;
        color: #666;
        text-align: center;
      }
    }
  }
</style>
